<template>
  <div class="content">
    <div class="menu">
      <div class="menu-con">
        <div class="menu-con-box" style="margin-bottom: 1.7vw" v-for="(data,index) in item" :key="index" @click="changeBgc(index)">
          <div class="menu-con-list menu-con-top" v-if="index === 0">
            <div class="menu-con-top-icon" :class="{'active-top':data.sign === 1}">
              <a>{{data.text}}</a>
            </div>
          </div>
          <div class="menu-con-list menu-con-bottom" v-if="index !== 0">
            <div class="menu-con-bottom-icon" :class="{'active-bottom':data.sign === 1}">
              <a>{{data.text}}</a>
            </div>
          </div>
        </div>
      </div>
      <img class="menu-icon" src="../../assets/box-3.png"/>
    </div>
    <div class="matter">
      <transition :name="transitionName">
        <router-view class="Router"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Management',
  data () {
    return {
      transitionName: 'slide-fade',
      item: [
        {text: '基础管理', sign: 0, path: ''},
        {text: '人员管理', sign: 0, path: '/management'},
        {text: '仓库管理', sign: 0, path: '/storehouse'},
        {text: '设备管理', sign: 0, path: '/equipment'},
        {text: '物料管理', sign: 0, path: '/material'},
        {text: '日志管理', sign: 0, path: '/log'}
      ]
    }
  },
  created () {
    let index = parseInt(this.$route.query.index)
    this.item.map((data, ind) => {
      if (index === ind) {
        data.sign = 1
      } else {
        data.sign = 0
      }
    })
    if (isNaN(index)) {
      this.item[1].sign = 1
    }
  },

  watch: {
    '$route' () {
      let index = parseInt(this.$route.query.index)
      this.item.map((data, ind) => {
        data.sign = 0
        if (index === ind) {
          data.sign = 1
        }
      })
      if (isNaN(index)) {
        this.item[0].sign = 1
      }
    }
  },
  methods: {
    changeBgc: function (index) {
      console.log(index)
      this.item.map((data, ind) => {
        if (index === ind && data.path !== '') {
          this.$router.push({
            path: data.path,
            query: {
              index: index
            }
          })
          data.sign = 0
          this.item[index].sign = 1
        }
      })
    }
  }
}
</script>

<style scoped>
@import "./Management.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/Management.vue